// @airbolt/sdk - Core SDK exports

// Main client class
export { Airbolt } from "./core/client";

// Core types and interfaces
export type {
  AirboltConfig,
  ChatMessage,
  ChatParams,
  ChatResult,
  StreamParams,
  StreamChunk,
  FetchOptions,
  RequestOptions,
  RequestHeaders,
  HttpMethod,
} from "./core/types";

// Error classes
export {
  AirboltError,
  AirboltNetworkError,
  createErrorFromResponse,
  createNetworkError,
  isRetryableError,
  isAirboltError,
} from "./core/errors";

// Essential utility functions
export {
  createHeaders,
  fetchWithRetry,
  validateProjectId,
  safeJsonParse,
  debugLog,
} from "./core/utils";

// Streaming utilities
export { parseVercelStream, collectStreamContent } from "./core/stream";

// Version information (will be updated by build process)
export const VERSION = "1.0.0";
